import { NavLink, Stack, Text } from "@mantine/core";

import { Link } from "react-router-dom";
import { MenuSubOption } from "@/types/pages/dashboard";
import styles from "./styles.module.scss";

interface DashboardSecondarySidebarProps {
  selectedSubmenuOption: string;
  changeSelectedSubmenuOption: (label: string) => void;
  menuTitle: string;
  menuSubOptions: MenuSubOption[];
}

export function DashboardSecondarySidebar({
  selectedSubmenuOption,
  changeSelectedSubmenuOption,
  menuTitle,
  menuSubOptions,
}: DashboardSecondarySidebarProps) {
  return (
    <Stack gap={8} className={styles.container}>
      <Text className={styles.title}>{menuTitle}</Text>

      {menuSubOptions.map(({ label, link }, i) => (
        <NavLink
          className={`${styles.navLink} ${
            selectedSubmenuOption === label && styles.selectedNavLink
          }`}
          key={i}
          label={label}
          component={Link}
          to={link}
          onClick={() => changeSelectedSubmenuOption(label)}
        />
      ))}
    </Stack>
  );
}
